//検索オープン
$(function () {
    $(".headerpc-sertch-btn,.overlay-search").on("click", function () {
      if ($(".header-search-area").hasClass("open")) {
        $(".header-search-area").removeClass("open");
        $(".overlay-search").removeClass("open");
      } else {
        $(".header-search-area").addClass("open");
        $(".overlay-search").addClass("open");
      }
    });
  });

//メインメニューオープン
$(function () {
    $(".header-spmenu-openbtn,.overlay").on("click", function () {
      if ($(".header-spmenu-nav").hasClass("open")) {
        $(".header-spmenu-nav,.header-spmenu-openbtn,html").removeClass("open");
        $(".overlay").css("display", "none");
      } else {
        $(".header-spmenu-nav,.header-spmenu-openbtn,html").addClass("open");
        $(".overlay").css("display", "block");
      }
    });
});
//スマホサブメニューオープン
$('.sp-havesubmenu').on('click', function(event) {
  event.preventDefault(); // デフォルトの動作を防止
  $(this).toggleClass('active'); // クリックした要素に'active'クラスをトグル
  $(this).next('.sp-submeu-area').slideToggle(); // 次の兄弟要素をスライドトグル
});

